module.exports = __webpack_public_path__ + "static/media/money.c7129150.svg";